module.exports = "<p ><i class=\"material-icons\">check </i> Application registration sucessfully  {{message}}</p>"